// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"864":"28dbd608","992":"831103bc"}[chunkId] + ".css";
};